import { RadioController } from "./radio";

class RadioItemController {
  isChecked: boolean;
  item: any;
  radioController: RadioController;
  name: string;
  index: number;
  ariaLabel: string;
  dataBiName: string;
  itemContent: string;
  // @ngInject
  constructor(private $element: ng.IAugmentedJQuery) {}

  $onInit() {
    this.name = this.radioController.name;
    if (this.item && angular.isString(this.item)) {
      this.itemContent = this.ariaLabel = this.dataBiName = this.item;
    } else if (this.item && this.radioController.displayMember && !angular.isArray(this.item)) {
      this.itemContent = this.ariaLabel = this.dataBiName = this.item[this.radioController.displayMember];
    } else {
      let label = "";
      let text = "";
      this.item.forEach((item: string) => {
        label = `${label} ${item}`;
        text = `${text} ${item} \n`;
      });

      this.itemContent = text;
      this.ariaLabel = this.dataBiName = label.trim();
    }
  }

  public getBIId() {
    return `${this.name}: radio item ${this.index + 1}`;
  }

  public isDisable() {
    if (this.item && this.item.isDisabled) {
      return true;
    } else {
      return false;
    }
  }
}
export const sdRadioItemText: ng.IComponentOptions = {
  bindings: {
    item: "<",
    index: "<"
  },
  controller: RadioItemController,
  templateUrl: "../ShellCommon/controls/radio/radio-item-text.html",
  require: {
    radioController: "^sdRadio"
  }
};
